import Typography from '@cobliteam/ui/components/Typography';
import type { ReactNode } from 'react';

interface DevToolsPanelProps {
  title: string;
  description?: ReactNode;
  /** Primary control for the panel (save, reset), right-aligned on the title row. */
  actions?: ReactNode;
  /** Filters and counters, on their own row under the title. */
  toolbar?: ReactNode;
  children: ReactNode;
}

/**
 * Shared shell for the Developer Tools panels. Each panel used to hand-roll its
 * own heading, description and action row with slightly different spacing, so
 * switching tabs shifted the content around.
 */
const DevToolsPanel = ({ title, description, actions, toolbar, children }: DevToolsPanelProps) => (
  <section className='flex flex-col gap-4'>
    <div className='flex items-start justify-between gap-4'>
      <div className='flex flex-col gap-1'>
        <Typography variant='heading-1'>{title}</Typography>
        {description ? (
          <Typography variant='body' color='secondary'>
            {description}
          </Typography>
        ) : null}
      </div>
      {actions ? <div className='flex shrink-0 items-center gap-2'>{actions}</div> : null}
    </div>

    {toolbar ? <div className='flex flex-wrap items-center gap-3'>{toolbar}</div> : null}

    {children}
  </section>
);

export default DevToolsPanel;
